export class TradeSizeExceedsError extends Error {
  public maxAmountIn: string;
  constructor(_maxAmountIn: string) {
    super("Trade size exceeds 40% of LP Pool");
    this.maxAmountIn = _maxAmountIn;
  }
}
